import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles
} from './models/control';
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { CalendarDayViewComponent } from './components/calendar/calendar-day-view.component';
import { CalendarEvent } from './components/calendar/calendar-utils';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_manufacturing_orders_calendar_ComponentContextService } from './FootprintManager.manufacturing_orders_calendar.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { FootprintManager_manufacturing_output_locations_simple_dd_multiComponent } from './FootprintManager.manufacturing_output_locations_simple_dd_multi.component'
import { Manufacturing_order_statuses_dd_singleComponent } from './Manufacturing.order_statuses_dd_single.component'


import { FootprintManager_manufacturing_orders_for_calendar_cardComponent } from './FootprintManager.manufacturing_orders_for_calendar_card.component';

interface IFootprintManager_manufacturing_orders_calendarComponentEntityData {
Id?: number, ActualCompleteOn?: string, ActualStartOn?: string, DefaultStagingLocationId?: number, EstimatedCompleteOn?: string, EstimatedStartOn?: string, LookupCode?: string, ManufacturingLocationId?: number, ProjectId?: number, StatusId?: number, WarehouseId?: number, OrderLines?: { Id?: number, PackagedAmount?: number, Material?: { Name?: string }, Tasks?: { ActualPackagedAmount?: number, OperationCodeId?: number }[] }[]}

interface IFootprintManager_manufacturing_orders_calendarComponentColumnData {
Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, ManufacturingLineFlag?: boolean, Name?: string, TypeId?: number, WarehouseId?: number, LocationContainersAssignedProjectsLookupLocationContainer?: { ProjectId?: number }[]}

interface IFootprintManager_manufacturing_orders_calendarComponentInParams {
  warehouse_ids?: number[], project_id?: number}


class FootprintManager_manufacturing_orders_calendarComponentCalendarEventModel extends CalendarEvent<IFootprintManager_manufacturing_orders_calendarComponentEntityData> {
  calendar: FootprintManager_manufacturing_orders_calendarComponent;
  
  //#region eventContent inParams


  get $eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_order_id(): number {

    const $calendar = this.calendar;
    const $utils = this.$utils;
    const $calendarEvent = this;

    const expr = $calendarEvent.entity.Id;
    
    return expr;
  }


  get $eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_lookup_code(): string {

    const $calendar = this.calendar;
    const $utils = this.$utils;
    const $calendarEvent = this;

    const expr = $calendarEvent.entity.LookupCode;
    
    return expr;
  }

  cacheValueFor_$eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_order_lines: string[];

  get $eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_order_lines(): string[] {

    const $calendar = this.calendar;
    const $utils = this.$utils;
    const $calendarEvent = this;

    const expr = $calendarEvent.entity.OrderLines.map(o => `${o.Material.Name} - ${Math.floor((o.Tasks.filter(t => t.OperationCodeId == 49).reduce((acc, item) => acc + item.ActualPackagedAmount, 0)-o.Tasks.filter(t => t.OperationCodeId == 60).reduce((acc, item) => acc + item.ActualPackagedAmount, 0))*100/o.PackagedAmount) || 0}% completed of ${o.PackagedAmount}`);
    
    if(!isEqual(this.cacheValueFor_$eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_order_lines, expr)) {
      this.cacheValueFor_$eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_order_lines = expr;
    }
    return this.cacheValueFor_$eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_order_lines;
  }


  get $eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_start_date(): string {

    const $calendar = this.calendar;
    const $utils = this.$utils;
    const $calendarEvent = this;

    const expr = $calendarEvent.entity.ActualStartOn ?? $calendarEvent.entity.EstimatedStartOn;
    
    return expr;
  }


  get $eventContent_FootprintManager_manufacturing_orders_for_calendar_card_inParams_end_date(): string {

    const $calendar = this.calendar;
    const $utils = this.$utils;
    const $calendarEvent = this;

    const expr = $calendarEvent.entity.ActualCompleteOn ?? $calendarEvent.entity.EstimatedCompleteOn;
    
    return expr;
  }
  //#endregion eventContent inParams


  constructor(
    private $utils: UtilsService) {
      super();
  }
}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_manufacturing_output_locations_simple_dd_multiComponent),
    forwardRef(() => Manufacturing_order_statuses_dd_singleComponent),
    forwardRef(() => FootprintManager_manufacturing_orders_for_calendar_cardComponent)
  ],
  selector: 'FootprintManager-manufacturing_orders_calendar',
  templateUrl: './FootprintManager.manufacturing_orders_calendar.component.html'
})
export class FootprintManager_manufacturing_orders_calendarComponent extends BaseComponent implements OnInit, OnChanges {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_manufacturing_orders_calendarComponentEntityData[];
  columns: IFootprintManager_manufacturing_orders_calendarComponentColumnData[];
  calendarEvents: FootprintManager_manufacturing_orders_calendarComponentCalendarEventModel[] = [];

  dayStartHour = 0;
  dayStartMinute = 0;
  dayEndHour = 23;
  dayEndMinute = 59;
  hourSegments = 2;
  hourSegmentHeight = 80;

  columnsPageSize = 5;
  columnsPageSkip = 0;
  columnsTotalCount = 0;
  calendarEventsTotalCount = 0;
  calendarEventsFetchedCount = 0;


  // TODO: 
  containerClass: string;



  inParams: IFootprintManager_manufacturing_orders_calendarComponentInParams = { warehouse_ids: [], project_id: null };


  //#region Variables
  vars: { start_date?: string, end_date?: string } = { };
  //#endregion
  //#region Events
  
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  @ViewChild('$calendarComponent', { read:  CalendarDayViewComponent}) $calendarComponent: CalendarDayViewComponent;

  @Input('warehouse_ids') set $inParams_warehouse_ids(value: any) {
    this.inParams['warehouse_ids'] = value;
  }
  get $inParams_warehouse_ids(): any {
    return this.inParams['warehouse_ids'] ;
  }
  @Input('project_id') set $inParams_project_id(value: any) {
    this.inParams['project_id'] = value;
  }
  get $inParams_project_id(): any {
    return this.inParams['project_id'] ;
  }

  topToolbar = {
      previous: new ToolModel(new ButtonModel('previous', new ButtonStyles(null, null), false, false, false, 'Previous', 'icon-ic_fluent_arrow_circle_left_20_regular', null)
    , false),
      today: new ToolModel(new ButtonModel('today', new ButtonStyles(null, null), false, false, false, 'Today', 'ms-Icon ms-Icon--GotoToday', null)
    , false),
      next: new ToolModel(new ButtonModel('next', new ButtonStyles(null, null), false, false, false, 'Next', 'icon-ic_fluent_arrow_circle_right_20_regular', null)
    , false)
  };

  formGroup: FormGroup = new FormGroup({
    view_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    output_location: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    state: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    view_date: new FieldModel(new DateBoxModel(this.formGroup.controls['view_date'] as DatexFormControl, null, false, false, '', 'date', null)
, new ControlContainerStyles(null, null), 'Current date', false, false),
    output_location: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['output_location'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Output location', false, false),
    state: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['state'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Completion state', false, false),
  }

  //#region filters inParams
  cacheValueFor_$fields_output_location_selector_inParams_warehouse_ids: number[];
  get $fields_output_location_selector_inParams_warehouse_ids(): number[] {
    const $calendar = this;
    const $utils = this.$utils;
    const expr = $calendar.inParams.warehouse_ids;
    
    if(!isEqual(this.cacheValueFor_$fields_output_location_selector_inParams_warehouse_ids, expr)) {
      this.cacheValueFor_$fields_output_location_selector_inParams_warehouse_ids = expr;
    }
    return this.cacheValueFor_$fields_output_location_selector_inParams_warehouse_ids;
  }

  get $fields_output_location_selector_inParams_project_id(): number {
    const $calendar = this;
    const $utils = this.$utils;
    const expr = $calendar.inParams.project_id;
    
    return expr;
  }

  //#endregion filters inParams

  constructor(private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_manufacturing_orders_calendar_ComponentContextService,
) {
    super();
    this.title = 'manufacturing_orders_calendar';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    const $calendar = this;
    const $utils = this.$utils;

    (this.filters.view_date.control as DateBoxModel).reset((new Date()).toISOString());

    await this.on_date_change();
    this.initialized = true;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearCalendarEvents();
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['view_date']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_date_change();
      });

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.columnsPageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $calendarEventPropertyChangeCallback (source: CalendarEvent, property: string): void {
    if (property === 'selected') {
      this.$calendarComponent.updateAllSelected();
    }
  }

  get viewDate(): string {
    const $calendar = this;
    const $utils = this.$utils;
    return $calendar.filters.view_date.control.value;
  }

  $matchEventToColumn(
    $column: IFootprintManager_manufacturing_orders_calendarComponentColumnData, 
    $calendarEvent: FootprintManager_manufacturing_orders_calendarComponentCalendarEventModel): boolean {
    const $calendar = this;
    const $utils = this.$utils;
    return $column.Id === $calendarEvent.entity?.ManufacturingLocationId;
  }

  async $dataLoad() {
    if(!this.formGroup.valid) {
      return;
    }

    await this.$dataLoadColumns();
    await this.$dataLoadEvents();
    await this.$dataLoaded();
  }

  async $dataLoadColumns() {
    const $calendar = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.columnsPageSize,
      $skip: this.columnsPageSkip,
      warehouse_ids:  $calendar.inParams.warehouse_ids ,
      full_text_search:  null ,
      project_id:  $calendar.inParams.project_id ,
      location_ids:  $calendar.filters.output_location.control.value ,
    };
    const data = await this.$datasources.Manufacturing.ds_get_manufacturing_output_locations_dd.getList(inParams);
    this.columns = data.result;
    this.columnsTotalCount = data.totalCount;
  }

  async $dataLoadEvents() {
    const $calendar = this;
    const $utils = this.$utils;
    const inParams = {
      start_of_day:  $calendar.vars.start_date ,
      end_of_day:  $calendar.vars.end_date ,
      order_status:  $calendar.filters.state.control.value ,
    };
    const data = await this.$datasources.Manufacturing.ds_get_manufacturing_orders_for_calendar.getList(inParams);
    this.entities = data.result;
    this.calendarEventsTotalCount = data.totalCount;
    this.calendarEventsFetchedCount = this.entities?.length;
  }  


  async $dataLoaded() {
    
    const calendarEvents = [];

    if(this.entities) {
      for (let entity of this.entities) {
        const $calendar = this;
        const $utils = this.$utils;        
        const $calendarEvent = new FootprintManager_manufacturing_orders_calendarComponentCalendarEventModel(this.$utils);
        $calendarEvent.entity = entity;
        $calendarEvent.calendar = this;

        $calendarEvent.startDate = $calendarEvent.entity.ActualStartOn ?? $calendarEvent.entity.EstimatedStartOn;
        $calendarEvent.endDate = $calendarEvent.entity.ActualCompleteOn ?? $calendarEvent.entity.EstimatedCompleteOn;
        $calendarEvent.title = $calendarEvent.entity.LookupCode;
        $calendarEvent.draggable = false;
        $calendarEvent.selected = false;

        let $isMatchEventToColumn = false;
        for (var column of this.columns) {
          if (this.$matchEventToColumn(column,$calendarEvent )) {
            $isMatchEventToColumn = true;
            break;
          }
        }
        if ($isMatchEventToColumn) {
          $calendarEvent.$propertyChangeCallback = this.$calendarEventPropertyChangeCallback.bind(this);
          calendarEvents.push($calendarEvent);
        }
      }
    }

    this.calendarEvents = calendarEvents;


  }

  async $columnsPageChange() {
    await this.$dataLoadColumns();
    await this.$dataLoaded();
  }

  $getHeaderHtml(
    $column: IFootprintManager_manufacturing_orders_calendarComponentColumnData
    ): string {
    const $calendar = this;
    const $utils = this.$utils;
    return `${$column.Name}`;
  }

  async $onHourSegmentClicked($orgEvent: {
    date: string;
    column: IFootprintManager_manufacturing_orders_calendarComponentColumnData
    sourceEvent: MouseEvent;
  }) {
    console.log('onHourSegmentClicked', $orgEvent);

    const $event = {date: $orgEvent.date, column: $orgEvent.column};
    const $calendar = this;
    const $shell = this.$shell;
    const $datasources = this.$datasources;
    const $flows = this.$flows;
    const $reports = this.$reports;
    const $settings = this.$settings;
    const $utils = this.$utils;

    const a = $event.column;
const d = $event.date;

$shell.FootprintManager.openmanufacturing_order_form();
  }


  clearCalendarEvents() {
    this.calendarEvents = [];
  }


  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_next(event = null) {
    return this.on_nextInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_nextInternal(
    $calendar: FootprintManager_manufacturing_orders_calendarComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_orders_calendar_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_calendar.on_next');
  
  $calendar.filters.view_date.control.value = $utils.date.add(1, 'day', $calendar.filters.view_date.control.value);
  $calendar.on_date_change();
  $calendar.refresh();
  }
  on_previous(event = null) {
    return this.on_previousInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_previousInternal(
    $calendar: FootprintManager_manufacturing_orders_calendarComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_orders_calendar_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_calendar.on_previous');
  
  $calendar.filters.view_date.control.value = $utils.date.add(-1, 'day', $calendar.filters.view_date.control.value);
  $calendar.on_date_change();
  $calendar.refresh();
  }
  on_today(event = null) {
    return this.on_todayInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_todayInternal(
    $calendar: FootprintManager_manufacturing_orders_calendarComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_orders_calendar_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_calendar.on_today');
  
  $calendar.filters.view_date.control.value = (new Date()).toISOString();
  $calendar.on_date_change();
  $calendar.refresh();
  }
  on_date_change(event = null) {
    return this.on_date_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_date_changeInternal(
    $calendar: FootprintManager_manufacturing_orders_calendarComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_manufacturing_orders_calendar_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'manufacturing_orders_calendar.on_date_change');
  
  const date = $calendar.filters.view_date.control.value;
  const start_datetime = new Date(date);
  start_datetime.setUTCHours(0, 0, 0, 0);
  
  const end_datetime = new Date(date);
  end_datetime.setUTCHours(23, 59, 59, 999);
  
  $calendar.vars.start_date = start_datetime.toISOString();
  $calendar.vars.end_date = end_datetime.toISOString();
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }

}
